import './rxjs-extensions';

import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { HttpModule,JsonpModule }    from '@angular/http';

import {ModalDirective} from 'ng2-bootstrap/ng2-bootstrap';
import { ModalModule } from 'ng2-bootstrap/modal';

import { AppRoutingModule } from './app-routing.module';
// import { InMemoryDataService }  from './in-memory-data.service';
import { AppComponent }         from './app.component';

import { PriceListService }          from './pricelist.service';
import { PricelistComponent }      from './pricelist.component'; 
import { PricelistDetailComponent }      from './pricelist-detail.component'; 
import { ApplicationContextService }          from './app-context.service'; 
import {ContactComponent }      from './contact.component';
import { AboutComponent }      from './about.component';
import { GardensComponent }      from './gardens.component';
import { LawnComponent }      from './lawn.component';
import { PoolsComponent }      from './pools.component';
import { PoolsDetailComponent }      from './pools-detail.component';
import { BallparkComponent }      from './ballpark.component';
import { LawnDetailComponent }      from './lawn-detail.component';
import { GardensDetailComponent }      from './gardens-detail.component';
import { ConstructionComponent }      from './construction.component';
import { ConstructionDetailComponent }     from './construction-detail.component';
import { ConsultComponent }      from './consult.component';
import { ConsultDetailComponent }      from './consult-detail.component';
import { TrellageComponent }      from './trellage.component'; 
import { TrellageDetailComponent }      from './trellage-detail.component';
import { WallsComponent }      from './walls.component'; 
import { WallsDetailComponent }      from './walls-detail.component'; 
import { FlowerbedsComponent }      from './flowerbeds.component'; 
import { RoofGardenComponent }      from './roofs.component';
import { ExtraIrrigationComponent }      from './extrairrigation.component'; 
import { IntraIrrigationComponent }      from './intrairrigation.component'; 
import { IrrigationControlComponent }      from './irrigationcontrol.component';  
import { IrrigationControlDetailComponent }      from './irrigationcontrol-detail.component';  
import { NavigationComponent }  from './nav.component';
import { LogoComponent }        from './logo.component';
import { ContentComponent }     from './content.component';
import { QuickLinkComponent }   from './quicklink.component'; 

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    ModalModule.forRoot(),
    AppRoutingModule

  ],
  declarations: [
    AppComponent,
    NavigationComponent,
    LogoComponent,
    ContentComponent,
    QuickLinkComponent, 
    ContactComponent,
    AboutComponent,
    GardensComponent,
    GardensDetailComponent,
    ConsultComponent,
    ConsultDetailComponent,
    ConstructionComponent,
    ConstructionDetailComponent,
    LawnComponent,
    LawnDetailComponent,
    PoolsComponent,
    PoolsDetailComponent,
    BallparkComponent,
    TrellageComponent,    
    TrellageDetailComponent,
    WallsComponent ,
    WallsDetailComponent ,
    FlowerbedsComponent,  
    RoofGardenComponent,
    ExtraIrrigationComponent,
    IntraIrrigationComponent,
    IrrigationControlComponent,
    IrrigationControlDetailComponent,
    PricelistComponent,  
    PricelistDetailComponent 
  ],
    providers: [ PriceListService, ApplicationContextService ],
    bootstrap: [ AppComponent ]
})

export class AppModule { }


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/